export default "__VITE_ASSET__Cc7T_s6d__"